import { getCurrentState } from '../store/store-utils';

const fetcher = (method, url, payload) => {
  const xhr = new XMLHttpRequest();
  return new Promise((resolve, reject) => {
    xhr.open(method, url);

    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.responseText);
      } else {
        reject(xhr.status);
      }
    };

    xhr.setRequestHeader('Content-Type', 'application/json');

    if (method !== 'GET') {
      const { csrfToken, csrfHeader } = getCurrentState().initialData;
      if (csrfToken && csrfHeader) {
        xhr.setRequestHeader(csrfHeader, csrfToken);
      }
    }
    if (method === 'POST') xhr.send(JSON.stringify(payload));
    else xhr.send();
  });
};
export default fetcher;
